/*
 * utils
 */
import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

export type ActionResponse<T = void> = {
	success: boolean
	data?: T
	error?: string
}
